import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gax-page-section-header-actions',
  templateUrl: './page-section-header-actions.component.html',
  styleUrl: './page-section-header-actions.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PageSectionHeaderActionsComponent {}
